import { ThemeOptions } from '@material-ui/core/styles/createTheme';

export const vivendaDoCamaraoTheme: ThemeOptions = {
  palette: {
    primary: {
      main: '#f15a23',
    },
    secondary: {
      main: '#008584',
    },
    /**
     * @todo add tertiary do cliente
     */
    tertiary: {
      main: '#E2E543',
    },
    additionalColors: {
      promoHighligts: '#f15a23',
    },
  },
};
